import React, { useState, useEffect, useCallback, memo } from 'react';
import { Input, Label } from '../../css/Shared';
import { useAppContext } from '../../context/AppContext';
import { toast } from 'react-toastify';
import Papa from 'papaparse';
import FacilitySearchSelect from '../../components/SearchableSelect';
import api from '../../components/Api';
/* ---------- Isolated new-seed form — has its own state, never re-renders parent ---------- */
const AddSeedRow = memo(({ onAdd }) => {
  const [newSeed, setNewSeed] = useState({ prefix: '',firstName: '',lastName: '',middleName: '',company: '',suffix: '',address1: '',address2: '', address3: '', city: '', state: '', zip: ''});

  const handleChange = useCallback((key) => (e) => {
    setNewSeed(p => ({ ...p, [key]: e.target.value }));
  }, []);

  const handleAdd = useCallback(() => {
   if (!newSeed.address1) { toast.error('Address required'); return; }
    onAdd(newSeed);
    setNewSeed({prefix: '',firstName: '',lastName: '',middleName: '',company: '',suffix: '',address1: '',address2: '', address3: '', city: '', state: '', zip: ''});
  }, [newSeed, onAdd]);

  return (
    <div className="grid grid-cols-2 md:grid-cols-6 lg:grid-cols-12 gap-2 items-center">
      {['prefix','firstName','lastName','middleName','company','suffix','address1','address2', 'address3', 'city', 'state', 'zip'].map(key => (
        <Input
          key={key}
          placeholder={key.charAt(0).toUpperCase() + key.slice(1)}
          value={newSeed[key]}
          onChange={handleChange(key)}
        />
      ))}
      <button type="button" onClick={handleAdd} className="btn-primary">Add</button>
    </div>
  );
});

/* ---------- Main Component ---------- */
const SeedListForm = ({
  onClose,
  seedList,
  setSeedLists,
  reset,
  setReset,
  normalizedFacilities
}) => {
  const { authState } = useAppContext();
console.log(seedList)
  const [formData, setFormData] = useState({
    seedListName: '',
    description: '',
    mailOwner: '',
    bmeuFacility: null,
    company: authState?.user.company
  });

  const [seeds, setSeeds] = useState([]);
  const [csvHeaders, setCsvHeaders] = useState([]);
  const [csvRows, setCsvRows] = useState([]);
  const [csvMapping, setCsvMapping] = useState({});

  useEffect(() => {
    if (seedList) {
      setFormData({
        seedListName: seedList.seedListName || '',
        description: seedList.description || '',
        mailOwner: seedList.mailOwner || '',
        bmeuFacility: seedList.bmeuFacility || null,
        company: authState?.user.company
      });
      setSeeds(seedList.seeds || []);
    } else {
      setFormData({
        seedListName: '',
        description: '',
        mailOwner: '',
        bmeuFacility: null,
        company: authState?.user.company
      });
      setSeeds([]);
    }
  }, [seedList, authState?.user.company]);

  // useCallback prevents MetaFields from re-rendering when seeds state changes
  const handleChange = useCallback((e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  }, []);

  const handleAddSeed = useCallback((seed) => {
    setSeeds(prev => [...prev, seed]);
  }, []);

  const removeSeed = useCallback((index) => {
    setSeeds(prev => prev.filter((_, i) => i !== index));
  }, []);


  const handleCsvUpload = useCallback((e) => {
  const file = e.target.files[0];
  if (!file) return;

  Papa.parse(file, {
    header: true,
    skipEmptyLines: true,
    complete: (results) => {
      let allRows = results.data || [];

      // Limit to first 5000 records
      const MAX_RECORDS = 2500;
      const originalLength = allRows.length;

      if (allRows.length > MAX_RECORDS) {
        allRows = allRows.slice(0, MAX_RECORDS);
        toast.info(`CSV has ${originalLength} rows — only the first ${MAX_RECORDS} records were loaded.`);
      } else if (allRows.length > 0) {
        toast.success(`CSV loaded (${allRows.length} records). Please map headers.`);
      } else {
        toast.warn('CSV appears to be empty or has no valid data rows.');
      }

      // Safe header extraction (handles empty file case)
      setCsvHeaders(allRows.length > 0 ? Object.keys(allRows[0] || {}) : []);
      setCsvRows(allRows);
    },
    error: (error) => {
      console.error('PapaParse error:', error);
      toast.error('Failed to parse the CSV file. Please check the file format.');
    }
  });
}, []);

//   const handleCsvUpload = useCallback((e) => {
//     const file = e.target.files[0];
//     if (!file) return;
//     Papa.parse(file, {
//       header: true,
//       skipEmptyLines: true,
//       complete: (results) => {
//         const allRows = results.data || [];
  
//         setCsvHeaders(Object.keys(allRows[0] || {}));
//         setCsvRows(allRows);
//         if (allRows.length > 5) {
//          toast.info(`CSV imported. Please set headers.`);
//         } else {
//           toast.success('CSV loaded. Please map headers.');
//         }
//       }
//     });
//   }, []);

const handleMappingChange = useCallback((field, value) => {
  setCsvMapping(prev => {
    if (prev[field] === value) return prev;
    return { ...prev, [field]: value };
  });
}, []);

  const applyCsvMapping = useCallback(() => {
  const requiredFields = ['prefix','firstName','lastName','middleName','company','suffix','address1','address2', 'address3', 'city', 'state', 'zip'];

  const mapped = csvRows.map(row => {
    const newRow = {};

    requiredFields.forEach(f => {
      const col = csvMapping[f];

      let value = col ? row[col] : '';

      // normalize prefix specifically
      if (f === 'prefix' && value) {
        value = String(value).trim().toUpperCase();
      }

      newRow[f] = value || '';
    });

    return newRow;
  });

  setSeeds(prev => [...prev, ...mapped]);

  setCsvHeaders([]);
  setCsvRows([]);
  setCsvMapping({});

  toast.success('CSV seeds added');
}, [csvRows, csvMapping]);
  // const applyCsvMapping = useCallback(() => {
  //   const requiredFields = ['prefix', 'address', 'city', 'state', 'zip', 'email'];
  //   const mapped = csvRows.map(row => {
  //     const newRow = {};
  //     requiredFields.forEach(f => { newRow[f] = row[csvMapping[f]] || ''; });
  //     return newRow;
  //   });
  //   setSeeds(prev => [...prev, ...mapped]);
  //   setCsvHeaders([]);
  //   setCsvRows([]);
  //   setCsvMapping({});
  //   toast.success('CSV seeds added');
  // }, [csvRows, csvMapping]);

// Replace the existing handleSubmit in SeedListForm.jsx with this:

const handleSubmit = useCallback(async (e) => {
  e.preventDefault();
  const isUpdate = Boolean(seedList);

  try {
    const payload = { ...formData, seeds };
console.log()
    const { data: savedSeedList } = isUpdate
      ? await api.put(`/permits/seeds/update/${seedList._id}`, payload)
      : await api.post(`/permits/seeds/new`, payload);

    if (typeof setSeedLists === 'function') {
      setSeedLists(prev =>
        isUpdate
          ? prev.map(sl => sl._id === savedSeedList._id ? savedSeedList : sl)
          : [savedSeedList, ...prev]
      );
    }

    toast.success(isUpdate ? 'Seed List updated' : 'Seed List created');
    if (typeof setReset === 'function') setReset(r => !r);
    onClose();

  } catch (err) {
    console.error(err);
    const message = err.response?.data?.message || err.message;
    toast.error(message || (isUpdate ? 'Error updating seed list' : 'Error creating seed list'));
  }
}, [formData, seeds, seedList, setSeedLists, setReset, onClose]);

  return (
    <div className="max-h-[80vh] overflow-y-auto max-w-6xl mx-auto px-6 py-4 text-sm [&_input]:h-9 [&_input]:text-sm [&_input]:px-3 [&_label]:text-xs">
      <form onSubmit={handleSubmit} className="space-y-6">
<div>
    <div> <h2 className="text-base font-semibold text-gray-800">
          {seedList ? 'Edit Seed List' : 'New Seed List'}
        </h2></div>
     <div className="flex justify-end gap-3 pt-2">
          <button type="button" onClick={onClose} className="btn-secondary">Cancel</button>
          <button type="submit" className="btn-primary">Save</button>
        </div>
</div>
 

<div style={{fontSize:"clamp(3rem,3rem,3rem)",display:'flex',justifyContent:"center"}}>{seeds.length <= 0 && seedList ? "Loading..." : ""}</div>
        <Section title="Seed List">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {/* InputGroup uses defaultValue (uncontrolled) so typing never causes a parent re-render */}
            <InputGroup label="Seed list name" name="seedListName" defaultValue={formData.seedListName} onChange={handleChange} />
            <InputGroup label="Description" name="description" defaultValue={formData.description} onChange={handleChange} />
          </div>
        </Section>

        <Section title="Seed Addresses">
          <div className="space-y-4">

            {/* AddSeedRow owns its own state — typing here is completely isolated from parent */}
            <AddSeedRow onAdd={handleAddSeed} />
<br />

            {/* CSV Upload */}
            <div className="space-y-2">
              <Label muted>Upload CSV</Label> <span style={{background:'rgb(255,255,0,.4)',padding:'3px',marginLeft:'40px'}}>Seed List Limit: 2500</span>
              <input type="file" accept=".csv" onChange={handleCsvUpload} className="border rounded p-1 w-full text-sm" />

              {csvHeaders.length > 0 && (
                <div className="mt-2 space-y-2 border p-2 rounded bg-gray-50">
                  <h4 className="text-xs font-medium text-gray-500 mb-2">Map CSV Columns</h4>
                  {['prefix','firstName','lastName','middleName','company','suffix','address1','address2', 'address3', 'city', 'state', 'zip'].map(field => (
                    <div key={field} className="flex flex-col md:flex-row items-start md:items-center gap-2">
<Label muted className="w-24 capitalize">
  {field.replace(/([A-Z])/g,' $1')}
</Label>
                      <select
                        value={csvMapping[field] || ''}
                        onChange={e => handleMappingChange(field, e.target.value)}
                        className="border rounded p-1 text-sm flex-1"
                      >
                        <option value="">Select CSV Column</option>
                        {csvHeaders.map(header => (
                          <option key={header} value={header}>{header}</option>
                        ))}
                      </select>
                    </div>
                  ))}
                  <button type="button" onClick={applyCsvMapping} className="btn-primary mt-2">Add CSV Seeds</button>
                </div>
              )}

              {csvRows.length > 0 && (
                <div className="mt-2 border rounded bg-gray-50 w-full max-h-64 overflow-y-auto">
                  <table className="w-full table-fixed text-sm border-collapse bg-white">
                    <thead className="text-xs text-gray-500 uppercase border-b bg-gray-100 sticky top-0 z-10 shadow-sm">
                      <tr>
                        {csvHeaders.map(header => (
                          <th key={header} className="px-3 py-2 text-left font-medium truncate bg-gray-100 z-20" title={header}>{header}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody className="divide-y">
                      {csvRows.map((row, i) => (
                        <CsvRow key={i} row={row} headers={csvHeaders} />
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>

            {/* Seeds table */}
            {seeds.length > 0 && (
           <div className="mt-4 border rounded bg-gray-50 w-full overflow-x-auto">
                <table className="hidden md:table w-full text-sm table-fixed border-collapse bg-white">
                  <thead className="text-xs text-gray-500 uppercase border-b bg-gray-100 sticky top-0 z-20 shadow-sm">
                    <tr>
                      {['prefix','firstName','lastName','middleName','company','suffix','address1','address2', 'address3', 'city', 'state', 'zip'].map(h => (
                        <th key={h} className="px-3 py-2 text-left font-medium truncate bg-gray-100 z-20">{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody className="divide-y">
                    {seeds.map((s, i) => (
                      <SeedRow key={i} seed={s} index={i} removeSeed={removeSeed} />
                    ))}
                  </tbody>
                </table>

                <div className="md:hidden space-y-3 p-3">
                  {seeds.map((s, i) => (
                    <SeedCard key={i} seed={s} index={i} removeSeed={removeSeed} />
                  ))}
                </div>
              </div>
            )}

          </div>
        </Section>

      {seeds?.length > 20 ? ( <div className="flex justify-end gap-3 pt-2">
          <button type="button" onClick={onClose} className="btn-secondary">Cancel</button>
          <button type="submit" className="btn-primary">Save</button>
        </div>) : ""
}

      </form>
    </div>
  );
};

/* ---------- Memoized CSV Row ---------- */
const CsvRow = memo(({ row, headers }) => (
  <tr className="border-b hover:bg-gray-50">
    {headers.map(header => (
      <td key={header} className="px-3 py-2 truncate" title={row[header] || '—'}>
        {row[header] || '—'}
      </td>
    ))}
  </tr>
));

/* ---------- Memoized Seed Row ---------- */
const SeedRow = memo(({ seed, index, removeSeed }) => (
  <tr className="border-b hover:bg-gray-50">
    {['prefix','firstName','lastName','middleName','company','suffix','address1','address2', 'address3', 'city', 'state', 'zip'].map(key => (
      <td key={key} className="px-3 py-2 truncate" title={seed[key] || '—'}>{seed[key] || '—'}</td>
    ))}
    <td className="px-3 py-2">
      <button onClick={() => removeSeed(index)} className="text-red-500 text-xs hover:text-red-700">Remove</button>
    </td>
  </tr>
));

/* ---------- Memoized Seed Card (mobile) ---------- */
const SeedCard = memo(({ seed, index, removeSeed }) => (
  <div className="border rounded p-3 bg-white shadow-sm text-sm space-y-1">

    <div className="font-semibold">
      {seed.prefix} {seed.firstName} {seed.middleName} {seed.lastName} {seed.suffix}
    </div>

    {seed.company && (
      <div className="text-gray-700">{seed.company}</div>
    )}

    <div className="text-gray-700">
      {seed.address1}
      {seed.address2 && <div>{seed.address2}</div>}
      {seed.address3 && <div>{seed.address3}</div>}
    </div>

    <div className="text-gray-600">
      {seed.city}, {seed.state} {seed.zip}
    </div>

    <button
      onClick={() => removeSeed(index)}
      className="text-red-600 hover:text-red-800 text-sm font-medium pt-2"
    >
      Remove
    </button>

  </div>
));

/* ---------- Helpers ---------- */
const Section = ({ title, children }) => (
  <section className="border rounded-lg p-4">
    <h3 className="text-xs font-medium text-gray-500 mb-3 uppercase tracking-wide">{title}</h3>
    {children}
  </section>
);

// defaultValue makes this uncontrolled — onChange fires but the input doesn't wait for React to re-render
const InputGroup = memo(({ label, name, defaultValue, onChange }) => (
  <div>
    <Label muted>{label}</Label>
    <Input name={name} defaultValue={defaultValue} onChange={onChange} />
  </div>
));

export default SeedListForm;
